<div id="compare-page" class="page-body-content">
  <form [formGroup]="form">
    <div>
      <div class="container results-header">
        <div class="row">
          <div class="col-11 justify-content-start">
            <div class="intro-title">Compare</div>
            <div class="intro-copy">
              Appreciate differences in your team members and what these differences mean for your relationships. First choose a subject, then choose
              two team members to see some short, actionable tips to help improve your team's interactions. Only team members with a personality type are available to compare.
            </div>
          </div>
        </div>
        <div class="row compare-top-band hdr-inputs compare-subject">
          <div class="col-md-6 col-sm-12">
            <div class="text-white semibold block compare-label">Choose subject...</div>
            <div class="dropdown-container dropdown-center">
              <course-dropdown
                formControlName="subject"
                preSelectedSubject="{{ selectedSubject }}"
                defaultText="Choose Subject..."
                [userDashboard]="userDashboard"
                (courseOutput)="setSubject($event)"
              ></course-dropdown>
            </div>
          </div>
          <div class="d-none d-md-block"></div>
        </div>
        <div class="row compare-top-band hdr-inputs compare-members">
          <div class="col-md-6 col-sm-12">
            <div class="text-white semibold block compare-label">Choose team member 1</div>
            <div class="dropdown-container dropdown-center">
              <div class="d-inline-block w-100 dropdown" ngbdropdown="">
                <mat-form-field appearance="outline">
                  <input
                    type="text"
                    placeholder="Choose Team Member"
                    aria-label="Team Member"
                    matInput
                    [formControl]="primaryCtrl"
                    [matAutocomplete]="primaryAuto"
                    #primaryTrigger="matAutocompleteTrigger"
                    (click)="teamMemberClicked(primaryTrigger)"
                  />
                  <mat-icon matSuffix>arrow_drop_down</mat-icon>
                  <mat-autocomplete #primaryAuto="matAutocomplete" [displayWith]="displayTeamMember" (opened)="primaryOpened()">
                    <mat-option *ngFor="let option of primaryOptions | async" [value]="option">
                      {{ option.firstName }} {{ option.lastName }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="text-white semibold block compare-label">Choose team member 2</div>
            <div class="dropdown-container dropdown-center">
              <mat-form-field appearance="outline">
                <input
                  type="text"
                  placeholder="Choose Team Member"
                  aria-label="Team Member"
                  matInput
                  [formControl]="secondaryCtrl"
                  [matAutocomplete]="secondaryAuto"
                  #secondaryTrigger="matAutocompleteTrigger"
                  (click)="teamMemberClicked(secondaryTrigger)"
                />
                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                <mat-autocomplete #secondaryAuto="matAutocomplete" [displayWith]="displayTeamMember" (opened)="secondaryOpened()">
                  <mat-option *ngFor="let option of secondaryOptions | async" [value]="option">
                    {{ option.firstName }} {{ option.lastName }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="grey-swipe"></div>
      </div>
    </div>
    <div>
      <div *ngIf="loadingData" class="spinner-container">
        <div class="d-flex justify-content-center">
          <div class="spinner-border custom-spinner" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <article *ngIf="displayResults" id="gettingalongcompare" class="gettingalongcompare">
        <div class="container d-lg-block d-none">
          <div class="row">
            <div class="col col-6">
              <div class="container content">
                <div class="row">
                  <div class="col-2">
                    <div class="diamond-shape">
                      <div class="mbtitype">{{ mbtiType }}</div>
                    </div>
                  </div>
                  <div class="col align-self-center name">{{ firstName }} {{ lastNameInitial }}.</div>
                </div>
                <div>
                  <div class="content compare-content" [innerHtml]="myTypeContent | safeHtml"></div>
                </div>
              </div>
            </div>
            <div class="col col-6">
              <div class="container content">
                <div class="row">
                  <div class="col-2">
                    <div class="diamond-shape">
                      <div class="mbtitype">{{ selectedType }}</div>
                    </div>
                  </div>
                  <div class="col align-self-center name">{{ friendFirstName }} {{ friendLastNameInitial }}.</div>
                </div>
                <div>
                  <div class="content compare-content" [innerHtml]="comparisonAgainstContent | safeHtml"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container d-md-block d-lg-none">
          <ul class="nav nav-tabs nav-justified">
            <li class="nav-item">
              <a class="nav-link active" data-bs-toggle="tab" href="#home">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="diamond-shape">
                      <div class="mbtitype">{{ mbtiType }}</div>
                    </div>
                  </div>
                  <div class="col-7 col-md-8 align-self-center name">{{ firstName }} {{ lastNameInitial }}.</div>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#menu1">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="diamond-shape">
                      <div class="mbtitype">{{ selectedType }}</div>
                    </div>
                  </div>
                  <div class="col-7 col-md-8 align-self-center name">{{ friendFirstName }} {{ friendLastNameInitial }}.</div>
                </div>
              </a>
            </li>
          </ul>

          <div class="tab-content">
            <div id="home" class="tab-pane container active">
              <div class="content" [innerHtml]="myTypeContent | safeHtml"></div>
            </div>
            <div id="menu1" class="tab-pane container fade">
              <div class="content" [innerHtml]="comparisonAgainstContent | safeHtml"></div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </form>
</div>
